module.exports = __webpack_public_path__ + "static/media/chevron-right.a47d4c64.svg";